import React, { createRef, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { deleteComment, loadComments, updateComment } from '../store/comments/actions';

import { Card } from 'react-bootstrap-5';

import LoadingSpinner from 'components/ui/loading_spinner';
import Comment from './comment';
import Input from './input';
import CommentModal from './modal';
import { scrollToRef } from 'helpers/scrolling';

import './styles.scss';

export function DealComments({ comments, deleteComment, loadComments, loading, updateComment }) {
  const commentsEndRef = createRef();
  const [scrollBehavior, setScrollBehavior] = useState('instant');
  const [modalComment, setModalComment] = useState(null);

  React.useEffect(() => {
    if (comments) {
      scrollToRef(commentsEndRef, { behavior: scrollBehavior });
      setScrollBehavior('smooth');
    } else {
      loadComments();
    }
  }, []);

  React.useEffect(() => {
    scrollToRef(commentsEndRef, { behavior: scrollBehavior });

    if (comments) {
      setScrollBehavior('smooth');
    }
  }, [comments]);

  const todayComments = [];
  const olderComments = [];

  if (comments) {
    comments.forEach((comment) => {
      if (new Date(comment.createdAt).toDateString() == new Date().toDateString()) {
        todayComments.push(comment);
      } else {
        olderComments.push(comment);
      }
    });
  }

  return (
    <Card className="deal-comments-sidebar">
      <Card.Header>
        <div className="fw-semibold">Messages</div>
      </Card.Header>

      <Card.Body className="d-flex justify-content-center p-0 overflow-hidden">
        {loading ? <LoadingSpinner/> :
          <div className="flex-fill d-flex flex-column gap-4 p-4 overflow-y-auto">
            {olderComments.map((comment, i) => (
              <Comment
                comment={comment}
                key={i}
                onDelete={deleteComment}
                onEdit={()=>setModalComment(comment)}
              />
            ))}
            {todayComments.length > 0 && (
              <div className="d-flex justify-content-between align-items-center gap-2">
                <div className="flex-fill border" />
                <div className="text-muted">Today</div>
                <div className="flex-fill border" />
              </div>
            )}
            {todayComments.map((comment, i) => (
              <Comment
                comment={comment}
                key={i}
                today
                onDelete={deleteComment}
                onEdit={()=>setModalComment(comment)}
              />
            ))}
            <span ref={commentsEndRef} />
          </div>
        }
        <CommentModal
          comment={modalComment}
          show={!!modalComment}
          updateComment={updateComment}
          onHide={() => setModalComment(null)}
        />
      </Card.Body>

      <Card.Footer>
        <Input submitOnEnter/>
      </Card.Footer>
    </Card>
  );
}

DealComments.propTypes = {
  comments: PropTypes.arrayOf(PropTypes.shape({
    createdAt: PropTypes.string.isRequired
  })),
  deleteComment: PropTypes.func.isRequired,
  loadComments: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  updateComment: PropTypes.func.isRequired,
};

const mapStateToProps = ({ comments: { comments, loading } }) => ({
  comments,
  loading,
});

const mapDispatchToProps = {
  deleteComment,
  loadComments,
  updateComment,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealComments);
